/**
 * DOCS
 * 
 * module de gestion de l'objet DOCS
 */
import { services } from "../../../../helpers/service";
const utils = require('../utils').default;

const DOCS = (() => {
    const ERROR_DOCS_LOAD_DOCS = 'Erreur de chargement de vos documents';
    const ERROR_DOCS_LOAD_DOCS_SERVICE_FAILED = 'Erreur de chargement de vos documents - erreur du service';
    const ERROR_DOCS_SAVE_DOCS = 'Erreur la sauvegarde de vos documents';
    const ERROR_DOCS_SAVE_DOCS_SERVICE_FAILED = 'Erreur la sauvegarde de vos documents - erreur du service';
    const ERROR_DOCS_LIST_NOT_FOUND = 'Erreur pendant la mise à jour de votre liste de documents. La liste n\'existe pas';
    const ERROR_DOCS_DELETE_DOC_NOT_FOUND = 'Erreur pendant la suppression de votre document. Le document n\'a pas été trouvé.';
    const ERROR_DOCS_ADD_DOC_ALREADY_EXIST = 'Erreur pendant l\'ajout de votre document. Le document existe déjà dans votre liste.';
    const SUCCESS_DOCS_DELETE = 'Le document a bien été supprimé de votre liste';
    const SUCCESS_DOCS_ADD = 'Le document a bien été ajouté à votre liste';

    let _DOCS = []

    /**
     * DOCS ADD DOCUMENT (func)
     * 
     * ajout d'un document
     * @param {string} groupId 
     * @param {string} id 
     * @param {string} name 
     * @param {string} url 
     * @param {string} imageSrc 
     * @returns {Promise}
     */
    const docsAddDocument = (groupId, id, name, url, imageSrc, type, typeId) => {
        return new Promise((resolve, reject) => {
            let docsGroup = _DOCS.filter((group) => utils.slug(group.name) === groupId);
            if (docsGroup.length === 0) reject(ERROR_DOCS_LIST_NOT_FOUND);
            let doc = docsGroup[0].list.filter((doc) => doc.id === id);
            if (doc.length !== 0) reject(ERROR_DOCS_ADD_DOC_ALREADY_EXIST);
            docsGroup[0].list.push({id, name, url, imageSrc, type, typeId});
            resolve({msg: SUCCESS_DOCS_ADD});
        })
    };
    /**
     * DOCS ADD GROUP (func)
     * 
     * ajout d'un nouveau group de document
     * @param {string} groupId 
     * @param {string} groupName 
     * @returns {Promise}
     */
    const docsAddGroup = (groupId, groupName, goupProductPageUrl) => {
        return new Promise((resolve, reject) => {
            _DOCS.push({
                'id': groupId,
                'name': groupName,
                'url': goupProductPageUrl,
                'list': [],
            })
            resolve();
        })
    };
    /**
     * DOCS DELETE (func)
     * 
     * Suppression d'un document
     * on verifie que le groupe et le document exist
     * @param {string} groupId 
     * @param {string} id 
     * @returns {Promise}
     */
    const docsDelete = (groupId, id) => {
        return new Promise((resolve, reject) => {
            let docsGroup = _DOCS.filter((group) => utils.slug(group.name) === groupId);
            if (docsGroup.length === 0) reject(ERROR_DOCS_LIST_NOT_FOUND);
            let doc = docsGroup[0].list.filter((doc) => doc.id === id);
            if (doc.length === 0) reject(ERROR_DOCS_DELETE_DOC_NOT_FOUND);
            docsGroup[0].list.splice(docsGroup[0].list.findIndex((doc) => doc.id === id), 1);
            if(docsGroup[0].list.length === 0 ){
                let grpindex = _DOCS.findIndex((obj) => obj.name === docsGroup[0].name);
                _DOCS.splice(grpindex , 1);
                _DOCS =  _DOCS != null ? _DOCS : []; 
            }
            resolve({msg: SUCCESS_DOCS_DELETE});
        })
    };
    /**
     * DOCS EXIST (func)
     * 
     * test si le document exist
     * @param {string} id 
     * @returns {Promise}
     */
    const docsExist = (id) => {
        return new Promise((resolve, reject) => {
            let docsGroup = _DOCS.filter((group) => utils.slug(group.name) === groupId);
            if (docsGroup.length === 0) reject(ERROR_DOCS_LIST_NOT_FOUND);
            let doc = docsGroup[0].list.filter((doc) => doc.id === id);
            if (doc.length === 0) reject(ERROR_DOCS_DELETE_DOC_NOT_FOUND);
            docsGroup[0].list.splice(docsGroup[0].list.findIndex((doc) => doc.id === id), 1);
            resolve({msg: SUCCESS_DOCS_DELETE});
        })
    };
    /**
     * DOCS GROUP EXIST (func)
     * 
     * test si group exist
     * @param {string} id 
     * @returns {bool}
     */
    const docsGroupExist = (id) => {
        return _DOCS.filter((group) => group.id === id).length ? true: false;
    };
    /**
     * DOCS LOAD
     * 
     * chargement via service DB des documents
     * @returns {Promise}
     */
    const docsLoad = () => {
        return new Promise ((resolve, reject) => {
            let datas = {};
            services.use('documentationproget', datas, null)
                .then((data) => {
                    utils.debug('DOCS LOAD', data);
                    if( data.error != undefined ){
                        reject(ERROR_DOCS_LOAD_DOCS);
                    } else {
                        docsObjectAssign(data);
                        // _DOCS = data;
                        resolve(data);
                    }
                }).catch(() => {
                    utils.debug('DOCS LOAD', 'erreur de chargement des documents');
                    reject(ERROR_DOCS_LOAD_DOCS_SERVICE_FAILED);
                });
        });
    };
    /**
     * DOCS OBJECT ASSIGN
     * 
     * on ré-assigne l'objet DB avec
     * l'objet local + test de l'intégrité 
     * de la présence de "list"
     * @param {object} data 
     */
    const docsObjectAssign = (data) => {
        Object.assign(_DOCS, data);
        _DOCS.forEach(docsGroup => {
            if (docsGroup.list === undefined) docsGroup.list = [];
        });
    };
    /**
     * DOCS SAVE (func)
     * 
     * enregistrement en DB via services des documents
     * @returns {Promise}
     */
    const docsSave = () => {
        return new Promise((resolve, reject) => {
            let data = {};
            data.data = getAllDocs();
            console.log('SAVE');
            console.log(data);
            services.use('documentationprosave', data, null)
                .then((data) => {
                    utils.debug('DOCS SAVE', data);
                    if( data != null &&  data.error != undefined ){
                        reject(ERROR_DOCS_SAVE_DOCS);
                    } else {
                        data = data == null ? [] : data ; 
                        docsObjectAssign(data);
                        resolve(data);
                    }
                }).catch(() => {
                    utils.debug('DOCS SAVE', 'erreur de sauvegarde des documents');
                    reject(ERROR_DOCS_SAVE_DOCS_SERVICE_FAILED);
                });
        });
    };
    /**
     * GET ALL DOCS (func)
     * 
     * getter de l'object docs
     * @returns {object}
     */
    const getAllDocs = () => {
        // sort by id asc
        _DOCS.sort((d1, d2) => {
            return d1.id < d2.id ? -1 : 1;
        });
        return _DOCS;
    };
    /**
     * GET DOCS COUNT
     * 
     * getter du nombre de documents total
     * @returns {number}
     */
    const getDocsCount = () => {
        let count = 0;
        _DOCS.forEach((docsGroup) => {
            count += docsGroup.list.length;
        })
        return count;
    };
    /**
     * GET DOCS GROUP (func)
     * 
     * récupération d'un group
     * @param {string} id 
     * @returns 
     */
    const getDocsGroup = (id) => {
        return _DOCS.filter((group) => group.id === id)[0];
    };
    return {
        _DOCS,
        docsAddDocument,
        docsAddGroup,
        docsDelete,
        docsExist,
        docsGroupExist,
        docsLoad,
        docsSave,
        // GETTER
        getAllDocs,
        getDocsCount,
        getDocsGroup,
    }
})();
export default DOCS;